import { Action } from '@ngrx/store';
import { IMessage } from 'src/app/models/message.interface';

export enum EMessageActions {
    GetMessage = '[Message] Get Message',
}

export class GetMessage implements Action {
    public readonly type = EMessageActions.GetMessage;
    constructor(public payload: IMessage) {}
}


export type MessageActions =
    | GetMessage;
